import React from "react";
import styles from "./index.module.scss";

const stylesConfig = (variant) => {
  switch (variant) {
    case `gray`:
      return styles.gray;
    case `light_blue`:
      return styles.light_blue;
    case `dark`:
      return styles.dark;
    case `white`:
      return styles.white;
    case `hidden`:
      return styles.hidden;
    default:
      return styles.default;
  }
};

/**
 *
 * Component Props
 * @param {children} props
 *
 */

const StyledContainer = (props) => (
  <div
    {...props}
    className={
      props.className + " " + `${styles.root} ${stylesConfig(props.variant)}`
    }
  >
    {props.children}
  </div>
);

export default StyledContainer;
